import React from 'react';
import InboxMessagesList from '../InboxMessagesList/InboxMessagesList';
import InboxAnnouncementsList from '../InboxAnnouncementsList/InboxAnnouncementsList';
import Search from 'src/components/Search/Search';
import Skeleton from 'src/components/Skeleton/Skeleton';
import './inbox-items-list.scss';
import {
  CustomPagination,
  useClientPagination,
  usePersistedPageState,
} from 'src/components/CustomPagination';
import useWindowSize from 'src/hooks/useWindowSize';

const MOBILE_LAYOUT_MAX_WIDTH = 768;
import { PageState } from 'src/components/CustomPagination/usePersistedPageState';

const SKELETON_ROW_COUNT = 7;

const ThreadListSkeleton = () => (
  <div aria-busy="true">
    {Array.from({ length: SKELETON_ROW_COUNT }, (_, index: number) => (
      <div key={index} className="skeleton-thread-row">
        <Skeleton variant="circle" width={44} height={44} />
        <div className="skeleton-thread-lines">
          <Skeleton variant="text" width="65%" height={13} />
          <Skeleton variant="text" width="40%" height={11} />
        </div>
      </div>
    ))}
  </div>
);

const InboxItemsList = ({
  type,
  inboxList,
  loadingInboxList,
  announcementsList,
  loadingAnnouncements,
  loadingPropertyAnnouncements,
  searchString,
  onSearch,
  onSelectItem,
  selectedId,
  persistKey,
}) => {
  const showListSkeleton: boolean =
    loadingInboxList || loadingAnnouncements || loadingPropertyAnnouncements;

  const persistedPageState: PageState = usePersistedPageState(persistKey);

  const {
    currentPage,
    totalPages,
    paginatedItems: paginatedTableData,
    showPaginationControls,
    setCurrentPage,
  } = useClientPagination<any>({
    items: inboxList,
    itemsPerPage: 100,
    pageStateFromRedux: persistedPageState,
  });

  const { windowSize } = useWindowSize();
  const isMobileLayout: boolean = windowSize.width <= MOBILE_LAYOUT_MAX_WIDTH;

  const showDetachedPaginationCard: boolean =
    showPaginationControls && isMobileLayout;

  const itemsListClassName: string = showDetachedPaginationCard
    ? 'inbox-items-list with-pagination-card'
    : 'inbox-items-list';

  const paginationControls = (
    <CustomPagination
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={setCurrentPage}
    />
  );

  return (
    <>
      <div className={itemsListClassName}>
        {(type === 'Messages' || type === 'Announcements') && (
          <div className="search-box">
            <Search
              value={searchString}
              placeholder={`Search ${type === 'Messages' ? 'Messages' : 'Announcements'}...`}
              onChange={onSearch}
              size={undefined}
              theme={undefined}
            />
          </div>
        )}
        <div className="thread-scroll">
          {showListSkeleton && <ThreadListSkeleton />}
          {!showListSkeleton &&
            (type === 'Messages' ||
              type === 'General' ||
              type === 'Service Request') && (
              <InboxMessagesList
                inboxList={paginatedTableData}
                onSelectItem={onSelectItem}
                selectedId={selectedId?.referenceId || ''}
                loader={showListSkeleton}
              />
            )}
          {!showListSkeleton && type === 'Announcements' && (
            <InboxAnnouncementsList
              announcementsList={announcementsList}
              onSelectItem={onSelectItem}
              selectedId={selectedId?.id || ''}
              loader={showListSkeleton}
            />
          )}
        </div>
        {showPaginationControls && !isMobileLayout && (
          <div className="list-pagination">{paginationControls}</div>
        )}
      </div>
      {showDetachedPaginationCard && (
        <div className="inbox-pagination-card">{paginationControls}</div>
      )}
    </>
  );
};

export default InboxItemsList;
